module.exports = __webpack_public_path__ + "img/small-2.b98132ac.jpg";